import React from "react";

const RecordingModal = ({ recordingUrl, showModal, onClose }) => {
  const [visible, setVisible] = React.useState(false);
  const [shouldRender, setShouldRender] = React.useState(showModal);

  React.useEffect(() => {
    if (showModal) {
      setShouldRender(true);
      setTimeout(() => setVisible(true), 10); 
      document.body.style.overflow = "hidden";
    } else {
      setVisible(false);
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [showModal]);

  // After fade-out, remove from DOM
  React.useEffect(() => {
    if (!visible && shouldRender) {
      const timeout = setTimeout(() => setShouldRender(false), 200);
      return () => clearTimeout(timeout);
    }
  }, [visible, shouldRender]);

  if (!shouldRender) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget && onClose) {
      onClose();
    }
  };

  return (
    <div
      className={`position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center modal-fade${visible ? ' show' : ''}`}
      style={{ background: "rgba(0, 0, 0, 0.6)", zIndex: 1050, transition: 'opacity 0.2s' , opacity: visible ? 1 : 0 }}
      onClick={handleOverlayClick}
    >
      <div
        className={`bg-white rounded shadow p-4 position-relative modal-content-fade${visible ? ' show' : ''}`}
        style={{ minWidth: 600, maxWidth: 900, transition: 'transform 0.4s, opacity 0.2s', transform: visible ? 'scale(1)' : 'scale(0.80)', opacity: visible ? 1 : 0 }}
      >
        <button
          type="button"
          className="btn-close position-absolute top-0 end-0 m-3"
          aria-label="Close"
          onClick={onClose}
        ></button>
        <h2 className="text-center mb-3">Recording</h2>
        {recordingUrl ? (
          <video autoPlay src={recordingUrl} controls className="w-100 h-100 mb-3" />
        ) : (
          <p className="text-center">No recording available.</p>
        )}
      </div>
    </div>
  );
};

export default RecordingModal;
